export const geneGroupProps = (geneName, onGeneClick) =>
  onGeneClick
    ? {
        onClick: () => onGeneClick(geneName),
        style: { cursor: "pointer" }
      }
    : {};
